import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { ShowcaseDesign } from '../../services';

export const fetchShowcaseDesign = createAsyncThunk(
    'showcaseDesign/fetchShowcaseDesign',
    async ({ id, filesSort, filesCol, filesClassname, titleSort, titleCol, titleClassname, descriptionSort, descriptionCol, descriptionClassname, contentSort, contentCol, contentClassname, specialField1Sort, specialField1Col, specialField1Classname, specialField2Sort, specialField2Col, specialField2Classname, specialField3Sort, specialField3Col, specialField3Classname, specialField4Sort, specialField4Col, specialField4Classname, specialField5Sort, specialField5Col, specialField5Classname, }) => {
        const response = await ShowcaseDesign(id, filesSort, filesCol, filesClassname, titleSort, titleCol, titleClassname, descriptionSort, descriptionCol, descriptionClassname, contentSort, contentCol, contentClassname, specialField1Sort, specialField1Col, specialField1Classname, specialField2Sort, specialField2Col, specialField2Classname, specialField3Sort, specialField3Col, specialField3Classname, specialField4Sort, specialField4Col, specialField4Classname, specialField5Sort, specialField5Col, specialField5Classname,)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const showcaseDesignSlice = createSlice({
    name: 'showcaseDesign',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowcaseDesign.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchShowcaseDesign.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchShowcaseDesign.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default showcaseDesignSlice.reducer;
